function normalizeLoginPart(value) {
  return String(value ?? '')
    .trim()
    .replace(/[äÄ]/g, 'ae')
    .replace(/[öÖ]/g, 'oe')
    .replace(/[üÜ]/g, 'ue')
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '')
    .trim();
}

function generateLoginName(vorname, nachname) {
  const first = normalizeLoginPart(vorname);
  const last = normalizeLoginPart(nachname);
  return [first, last]
    .filter(Boolean)
    .join('.')
    .replace(/\.+/g, '.')
    .replace(/^\.+|\.+$/g, '');
}

export {
  generateLoginName,
  normalizeLoginPart
};
